import script from "./TeamManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamManagement.vue?vue&type=script&setup=true&lang=js"

import "./TeamManagement.vue?vue&type=style&index=0&id=50f1221b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f1221b"]])

export default __exports__